const Handedness = {
    Right: { key: 'R', name: 'Right', against: 'RHP', shortName: 'R' },
    Left: { key: 'L', name: 'Left',  against: 'LHP', shortName: 'L' },
    Switch: { key: 'S', name: 'Switch', against: 'S',  shortName: 'S'},
    Unidentified: { key: 'UI', name: 'Unidentified', against: '-',  shortName: '-'} 
};

export default Handedness;